/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StkIssFServ01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const stkIssFServ01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const stkIssFServ01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const stkIssFServ01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const stkIssFServ01ExportLoading = (state, { boolean }) => ({
  ...state,
  exportIsLoading: boolean
});

export const stkIssFServ01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const stkIssFServ01FetchStkIssFServ01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const stkIssFServ01FetchStkIssFServ01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const stkIssFServ01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const stkIssFServ01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const stkIssFServ01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const stkIssFServ01ExportSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StkIssFServ01Types.STK_ISS_F_SERV01_SHOW_SYNC_SETTING_LOADING]: stkIssFServ01ShowSyncSettingLoading,
  [StkIssFServ01Types.STK_ISS_F_SERV01_SHOW_SYNC_SETTING_SUCCESS]: stkIssFServ01ShowSyncSettingSuccess,
  [StkIssFServ01Types.STK_ISS_F_SERV01_SHOW_BATCH_JOB_STATUS_SUCCESS]: stkIssFServ01ShowBatchJobStatusSuccess,

  [StkIssFServ01Types.STK_ISS_F_SERV01_RESET_TIMESTAMP]: stkIssFServ01ResetTimestamp,
  [StkIssFServ01Types.STK_ISS_F_SERV01_FETCH_STK_ISS_F_SERV01_LOADING]: stkIssFServ01FetchStkIssFServ01Loading,
  [StkIssFServ01Types.STK_ISS_F_SERV01_FETCH_STK_ISS_F_SERV01_SUCCESS]: stkIssFServ01FetchStkIssFServ01Success,
  [StkIssFServ01Types.STK_ISS_F_SERV01_ADD_SELECTED_DOCUMENTS]: stkIssFServ01AddSelectedDocuments,
  [StkIssFServ01Types.STK_ISS_F_SERV01_REMOVE_SELECTED_DOCUMENTS]: stkIssFServ01RemoveSelectedDocuments,
  [StkIssFServ01Types.STK_ISS_F_SERV01_SET_WORKSPACE_VISIBLE]: stkIssFServ01SetWorkspaceVisible,
  [StkIssFServ01Types.STK_ISS_F_SERV01_EXPORT_LOADING]: stkIssFServ01ExportLoading,
  [StkIssFServ01Types.STK_ISS_F_SERV01_EXPORT_SUCCESS]: stkIssFServ01ExportSuccess
});
